import { render, staticRenderFns } from "./charger.vue?vue&type=template&id=4dfadffa&scoped=true"
import script from "./charger.vue?vue&type=script&lang=js"
export * from "./charger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfadffa",
  null
  
)

export default component.exports